import { render, staticRenderFns } from "./TopMenuLight.vue?vue&type=template&id=7560b5ca&scoped=true&"
import script from "./TopMenuLight.vue?vue&type=script&lang=ts&"
export * from "./TopMenuLight.vue?vue&type=script&lang=ts&"
import style0 from "./TopMenuLight.vue?vue&type=style&index=0&id=7560b5ca&lnag=css&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7560b5ca",
  null
  
)

export default component.exports